<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  multiTemplateDataRows
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
  cdkDropList
  cdkDropListOrientation="horizontal"
  (cdkDropListDropped)="reorderColumns($event)"
  (click)="$event.stopPropagation()"
>
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns; let i = index">
    <mat-header-cell
      *matHeaderCellDef
      cdkDrag
      cdkDragLockAxis="x"
      cdkDragBoundary="mat-header-row"
      (mousedown)="onResizeColumn($event, i)"
      [cdkDragDisabled]="column === 'actions'"
      (click)="$event.stopPropagation()"
    >
      <sn-icon
        *ngIf="column !== 'actions'"
        cdkDragHandle
        class="draggable"
        (click)="$event.stopPropagation()"
        >drag_indicator</sn-icon
      >
      {{ column }}
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container [ngSwitch]="column">
        <ng-container *ngSwitchCase="'plateState'">
          <span class="text-truncate">{{ item.properties.hotlistData?.plateState }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'reason'">
          <span class="text-truncate">{{ item.properties['reason'] }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'createdBy'">
          <span class="text-truncate">{{ item.createdBy?.fullName }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'createdAt'">
          <span class="text-truncate">{{ item.createAt | fsFormatDate : 'medium' }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'expiresAt'">
          <span class="text-truncate">{{ item.expiresAt | fsFormatDate : 'medium' }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'actions'">
          <sn-action-list
            [items]="actions"
            [context]="item"
            alwaysCollapse
            class="actionsMenu"
          ></sn-action-list>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <span *ngIf="isDefault(column)" class="text-truncate">{{ item[column] }}</span>
          <span
            *ngIf="!isDefault(column)"
            class="text-truncate"
            [matTooltip]="getField(item, column)"
            >{{ getField(item, column) }}</span
          >
        </ng-container>
      </ng-container>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    [@snFadeIn]
    [@snFadeOut]
    *matRowDef="let item; columns: columns"
    (click)="$event.stopPropagation()"
  ></mat-row>
</mat-table>
